// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3hYPx","label":"CategoryService_label__2Ii0m","location":"CategoryService_location__2eoQK"};